/**
 * The number a client pays EcoCash from (InGo ADR 0048): the server's
 * `EcoCashNumber`, twinned so the app can say "that is not an EcoCash number"
 * before anything is booked. EcoCash wallets are Econet lines, 077 and 078;
 * EcoCash writes them `2637XXXXXXXX`. The server judges again: this only
 * saves the client a round trip.
 */

/** The number as EcoCash takes it, or null when it is not an EcoCash line. */
export function ecocashNumber(typed) {
  const digits = String(typed ?? '').replace(/\D/g, '');
  let full;
  if (digits.startsWith('263')) full = digits;
  else if (digits.startsWith('0')) full = `263${digits.slice(1)}`;
  else full = `263${digits}`;

  return /^2637[78]\d{7}$/.test(full) ? full : null;
}

/** As the client reads it back, never in full: "0772 ••• 456". */
export function ecocashMasked(msisdn) {
  const digits = String(msisdn ?? '').replace(/\D/g, '');

  return digits.length === 12 ? `0${digits.slice(3, 6)} ••• ${digits.slice(-3)}` : `••• ${digits.slice(-3)}`;
}
